/*
 * Artwork fee link
 * ----------------
 * The Custom Artwork Builder adds two cart lines together: the pedal and a
 * "Custom Artwork fee" product. They are linked by a shared hidden property —
 * the pedal line carries `_artwork_pedal_ref` and the fee line carries
 * `_artwork_fee_ref` (same value). When the pedal line is removed (or zeroed),
 * its fee line becomes an orphan; this watcher removes orphaned fee lines on
 * every cart update so the fee never lingers without its pedal.
 */
(function () {
  if (window.__artworkFeeLinkInit) return;
  window.__artworkFeeLinkInit = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_URL = ROOT + 'cart.js';
  var CHANGE_URL = ROOT + 'cart/change.js';

  var sweeping = false;
  var rerun = false;

  function getCart() {
    return fetch(CART_URL, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  // Fee lines whose linked pedal line is no longer present in the cart.
  function findOrphanFeeKeys(cart) {
    var pedalRefs = {};
    (cart.items || []).forEach(function (item) {
      var ref = item.properties && item.properties._artwork_pedal_ref;
      if (ref) pedalRefs[ref] = true;
    });
    var orphans = [];
    (cart.items || []).forEach(function (item) {
      var ref = item.properties && item.properties._artwork_fee_ref;
      if (ref && !pedalRefs[ref]) orphans.push(item.key);
    });
    return orphans;
  }

  function getInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector || '.shopify-section');
    return el ? el.innerHTML : '';
  }

  function sectionsForComponent(component, type) {
    try {
      var list = component.getSectionsToRender();
      return list
        .map(function (s) { return type === 'drawer' ? s.id : s.section; })
        .filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  // Remove the given line keys, requesting fresh section HTML on the last call.
  function removeKeys(keys, sections) {
    var chain = Promise.resolve(null);
    keys.forEach(function (key, i) {
      var isLast = i === keys.length - 1;
      chain = chain.then(function () {
        var body = { id: key, quantity: 0 };
        if (isLast && sections.length) {
          body.sections = sections;
          body.sections_url = window.location.pathname;
        }
        return fetch(CHANGE_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json(); });
      });
    });
    return chain;
  }

  // Re-render the visible cart UI using the parsed cart state returned by change.js.
  function render(parsedState) {
    if (!parsedState) return;

    var cartItems = document.querySelector('cart-items');
    var cartDrawer = document.querySelector('cart-drawer');

    if (cartItems && document.getElementById('main-cart-items')) {
      // Main cart page — mirror CartItems' own render loop.
      var cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      if (cartDrawer) cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);

      try {
        cartItems.getSectionsToRender().forEach(function (section) {
          var target =
            (document.getElementById(section.id) &&
              document.getElementById(section.id).querySelector(section.selector)) ||
            document.getElementById(section.id);
          var html = parsedState.sections && parsedState.sections[section.section];
          if (target && html) target.innerHTML = getInnerHTML(html, section.selector);
        });
      } catch (e) { /* non-fatal — cart already updated server-side */ }
    } else if (cartDrawer) {
      // Drawer context — reuse its own renderer.
      if (cartDrawer.classList.contains('is-empty') && parsedState.item_count > 0) {
        cartDrawer.classList.remove('is-empty');
      }
      cartDrawer.classList.toggle('is-empty', parsedState.item_count === 0);
      try {
        cartDrawer.getSectionsToRender().forEach(function (section) {
          var target = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          var html = parsedState.sections && parsedState.sections[section.id];
          if (target && html) target.innerHTML = getInnerHTML(html, section.selector);
        });
      } catch (e) { /* non-fatal */ }
    }
  }

  function sweep() {
    if (sweeping) {
      rerun = true;
      return;
    }
    sweeping = true;

    getCart()
      .then(function (cart) {
        var orphans = findOrphanFeeKeys(cart);
        if (!orphans.length) return null;

        var cartItems = document.querySelector('cart-items');
        var cartDrawer = document.querySelector('cart-drawer');
        var sections =
          cartItems && document.getElementById('main-cart-items')
            ? sectionsForComponent(cartItems, 'cart')
            : cartDrawer
            ? sectionsForComponent(cartDrawer, 'drawer')
            : [];

        return removeKeys(orphans, sections).then(render);
      })
      .catch(function () { /* ignore — fee just stays until next change */ })
      .then(function () {
        sweeping = false;
        if (rerun) {
          rerun = false;
          sweep();
        }
      });
  }

  // The theme publishes cartUpdate after every cart mutation.
  function bind() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, sweep);
    }
    // Catch removals fired straight on the cart-items element too.
    document.addEventListener('cart:change', sweep);
    // Clean up any orphan left over from a previous page/session.
    sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
